<template>
  <section class="mt-10">
    <div class="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
      <div class="border-b dark:border-gray-700 mx-4">
        <div class="flex items-center justify-between space-x-4 pt-3">
          <div class="flex-1 flex items-center space-x-3">
            <h5 class="dark:text-white font-semibold">
              Users
            </h5>
          </div>
        </div>
        <div class="flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3">
          <div class="w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center">
            <form class="w-full md:max-w-sm flex-1 md:mr-4">
              <label
                class="text-sm font-medium text-gray-900 sr-only dark:text-white"
                for="user-search"
              >Search</label>
              <input
                id="user-search"
                v-model="searchQuery"
                class="block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search users..."
                type="search"
              >
            </form>
          </div>
          <div
            class="w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0"
          >
            <button
              class="flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
              type="button"
            >
              <svg
                class="h-3.5 w-3.5 mr-2"
                fill="none"
                height="12"
                viewBox="0 0 12 12"
                width="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0.75V11.25M0.75 6H11.25"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </svg>
              Add New User
            </button>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Name
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Status
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Email
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Created At
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                <span class="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(user, index) in filteredUsers"
              :key="user._id || index"
              class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <th
                class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                scope="row"
              >
                <span>{{ user.fullName }}</span>
              </th>
              <td class="px-4 py-2 whitespace-nowrap">
                <span
                  v-if="user.isActive"
                  class="bg-green-400 text-white text-xs font-medium px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"
                >Active</span>
                <span
                  v-if="!user.isActive"
                  class="bg-green-400 text-white text-xs font-medium px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"
                >Inactive</span>
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                <div class="flex -space-x-4 w-28">
                  {{ user.email }}
                </div>
              </td>
              <td class="px-4 py-2 font-medium whitespace-nowrap">
                <div class="flex -space-x-4 w-28">
                  {{ user.createdAt }}
                </div>
              </td>
              <td class="px-4 py-2 flex justify-end">
                <router-link
                  :to="`/administrator/users/user/${user._id}`"
                  class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="#000000"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <title />
                      <g id="Complete">
                        <g id="edit">
                          <g>
                            <path
                              d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                              fill="none"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                            <polygon
                              fill="none"
                              points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span>Edit User</span>
                </router-link>
                <button
                  class="flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-red-500 bg-white border border-red-400 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                  @click="deleteUser(user._id)"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M4 7H20"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                  <span>Delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav
        aria-label="Table navigation"
        class="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
      >
        <span
          class="text-sm font-normal text-gray-500 dark:text-gray-400"
        > Showing <span
          class="font-semibold text-gray-900 dark:text-white"
        >1-10</span> of <span
          class="font-semibold text-gray-900 dark:text-white"
        >{{ users.length }}</span> </span>
        <ul class="inline-flex items-stretch -space-x-px">
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Previous</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >0</a>
          </li>
          <li>
            <a
              aria-current="page"
              class="flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >...</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Next</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent, watchEffect} from 'vue';
import axios from 'axios';
import {User} from '@/types';
import {useHead} from "@vueuse/head";

export default defineComponent({
  name: 'Users',
  setup() {
    watchEffect(() => {
      useHead({
        title: 'Users',
      });
    });
  },
  data() {
    return {
      users: [] as User[],
      filteredUsers: [] as User[],
      loading: false,
      error: null as string | null,
      searchQuery: '',
    };
  },
  watch: {
    searchQuery() {
      this.filterUsers();
    }
  },
  async mounted() {
    this.loading = true;
    try {
      const response = await axios.get('user/all');
      this.users = response.data;
      this.filteredUsers = response.data;
    } catch (err) {
      console.error(err);
      this.error = 'An error occurred while fetching the users.';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    filterUsers() {
      if (!this.users) return;
      this.filteredUsers = this.searchQuery.trim()
          ? this.users.filter((user) =>
              user.fullName.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
          : this.users;
    },
    async deleteUser(id: string) {
      if (!id) return;
      const confirmed = window.confirm('Are you sure you want to delete this user?');
      if (!confirmed) return;

      this.loading = true;
      try {
        await axios.delete(`user/delete/${id}`);
        this.users = this.users.filter((user) => user._id !== id);
        this.filteredUsers = this.filteredUsers.filter((user) => user._id !== id);
      } catch (err) {
        console.error(err);
        this.error = 'An error occurred while deleting the user.';
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
